// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createProductDescriptionStyles } from "@guestsupply/App/SharedStyles/productDescriptionStyles";
import { createHorizontalSmallHeadingAndTextStyles } from "@guestsupply/App/SharedStyles/smallHeadingAndTextStyles";
import {
    autocompleteProductsStyles,
    AutocompleteProductsStyles,
} from "@guestsupply/Overrides/Widgets/Header/AutocompleteProducts";
import { mergeWithCss } from "@guestsupply/XDL/Utilities/mergeWithCss";
import { css } from "styled-components";

const autocompleteProductsStylesExtensions: AutocompleteProductsStyles = {
    headerText: {
        weight: "bold",
        css: css`
            text-align: left;
            margin: 10px 0 5px 0;
        `,
    },
    container: {
        css: css`
            display: flex;
            gap: 12px;
            margin-bottom: 16px;
        `,
    },
    focusedContainer: {
        gap: 0,
        css: css`
            flex-grow: 0;
            margin: 5px 0;
            cursor: pointer;
            background-color: lightgray;
        `,
    },
    imageGridItem: {
        width: 3,
        css: css`
            max-width: 98px;
            max-height: 98px;
            flex-basis: 98px;
        `,
    },
    image: {
        css: css`
            width: 98px;
            min-width: 98px;
            height: 98px;
            & > img {
                max-width: 100%;
                max-height: 100%;
                height: auto;
                width: auto;
                border-radius: 4px;
            }
        `,
    },
    infoGridItem: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 12px;
        `,
    },
    skuAndDescriptionContainer: {
        css: css`
            display: flex;
            flex-direction: column;
        `,
    },
    titleLink: {
        ...mergeWithCss(createProductDescriptionStyles().productDetailLink, {
            css: css`
                align-items: baseline;
            `,
            typographyProps: {
                css: css`
                    &&& {
                        font-size: 12px;
                    }
                `,
            },
        }),
    },
    erpNumberText: {
        ...createHorizontalSmallHeadingAndTextStyles(),
    },
};

autocompleteProductsStyles.headerText = autocompleteProductsStylesExtensions.headerText;
autocompleteProductsStyles.container = autocompleteProductsStylesExtensions.container;
autocompleteProductsStyles.focusedContainer = autocompleteProductsStylesExtensions.focusedContainer;
autocompleteProductsStyles.imageGridItem = autocompleteProductsStylesExtensions.imageGridItem;
autocompleteProductsStyles.image = autocompleteProductsStylesExtensions.image;
autocompleteProductsStyles.infoGridItem = autocompleteProductsStylesExtensions.infoGridItem;
autocompleteProductsStyles.titleLink = autocompleteProductsStylesExtensions.titleLink;
autocompleteProductsStyles.erpNumberText = autocompleteProductsStylesExtensions.erpNumberText;
autocompleteProductsStyles.skuAndDescriptionContainer = autocompleteProductsStylesExtensions.skuAndDescriptionContainer;
